import React, { useEffect } from 'react'
import { useParams } from 'react-router'

import { APIBASE } from '../config.js'

const UrlShortener = () => {
  const { id } = useParams<{ id: string }>()

  useEffect(() => {
    window.location.replace(`${APIBASE}/v1/r/${id}`)
  }, [])

  return <div />
}

export default UrlShortener
